import { IFormChecklistItem } from "../types";
import { selectorChecklistOrder } from "./selectorChecklistOrder";

/**
 * Orders a checklist and derives the completion summary in one place, shared
 * by every checklist data source (the pair-scoped /checklist read and the
 * per-instance status reads) so they can't drift on ordering or "all
 * complete" semantics.
 */
export const selectorChecklistViewFromItems = (
  items: IFormChecklistItem[]
): {
  orderedItems: IFormChecklistItem[];
  allCompleted: boolean;
  completedCount: number;
} => {
  const orderedItems = selectorChecklistOrder(items);
  const allCompleted =
    orderedItems.length > 0 &&
    orderedItems.every(item => item.status === "Completed");
  const completedCount = orderedItems.filter(
    item => item.status === "Completed"
  ).length;

  return { orderedItems, allCompleted, completedCount };
};
